module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort@2x-302119596dd4c2f55ad464b1a16f8840.webp";